<template>
    <FormSelect field="title" v-if="lang == 'he'">   
        <option value="">אנא בחר</option>      
        <option value="Mr">מר</option>
        <option value="Mrs.">מרת</option>
        <option value="Ms.">גברת</option>
        <option value="Rabbi">רב</option>
        <option value="Rabbanit">רבנית</option>
        <option value="Dr.">דר</option>
        <option value="Dr. Rabbi">דר רב</option>
        <option value="Rabbi Dr." v-if="!simple">רב דר</option>
        <option value="Sir">אדון</option>
        <option value="The honorable">המכובד</option>
        <option value="Chaplain">כומר</option>
    </FormSelect>
    <FormSelect field="title" v-else-if="lang == 'esp'">  
        <option value="">Seleccione</option>    
        <option value="Mr">Señor</option>
        <option value="Mrs.">Sra.</option>
        <option value="Ms.">Milisegunda.</option>
        <option value="Rabbi">Rabina</option>
        <option value="Dr.">La doctora</option>
        <option value="Dr. Rabbi"> Dr. Rabino</option>
        <option value="Rabbi Dr." v-if="!simple">Rabino Dr.</option>
        <option value="Sir">Señor</option>
        <option value="The honorable">La honorable</option>
        <option value="Chaplain">Capellán</option>
    </FormSelect>
    <FormSelect field="title" v-else>      
        <option value="">Select</option>
        <option value="Mr">Mr.</option>
        <option value="Mrs.">Mrs.</option>
        <option value="Ms.">Ms.</option>
        <option value="Rabbi">Rabbi</option>
        <option value="Rebbetzin">Rebbetzin</option>
        <option value="Rabbanit">Rabbanit</option>
        <option value="Dr.">Dr.</option>
        <option value="Dr. Rabbi">Dr. Rabbi</option>
        <option value="Rabbi Dr." v-if="!simple">Rabbi Dr.</option>
        <option value="Sir">Sir</option>
        <option value="The honorable">The Honorable</option>
        <option value="Chaplain">Chaplain</option>
    </FormSelect>
</template>
<script setup lang="ts">
withDefaults(defineProps<{
  lang?: string
  simple?: boolean
}>(), {
  simple: false
})
</script>